const jwtServiceConfig = {
  signIn: 'api/auth/sign-in',
  accessToken: 'api/auth/access-token',
  updateUser: 'api/auth/user/update',
};

export default jwtServiceConfig;
